import { UserMenu } from '../UserMenu'

/**
 * `UserMenu` variant for locked worker sessions: avatar, name, the theme switch and sign-out.
 * The account navigation links are removed via the `AccountLinks` slot so the
 * user cannot navigate away from the page. Wired in `Layout.js` for `isWorker`.
 */
function UserMenuLogoutOnly({ ref, ...props }) {
  return <UserMenu {...props} AccountLinks={null} ref={ref} />
}

export default UserMenuLogoutOnly
